export var tabbarHeight = 48;